var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg07(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "157.24mm",
    height: "109.61mm",
    viewBox: "0 0 157.24 109.61",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath5890"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1.4305e-5 0h960v540h-960z",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath5930"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 540h960v-540l-960 6.1035e-5",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath5940"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 540h960v-540l-960 6.1035e-5",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath5950"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-3.0518e-5 540h960v-540h-960",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath5960"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-3.0518e-5 540h960v-540h-960",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath5974"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m399.67 173.19 34.86-33.88-33.89-34.86-34.86 33.89z",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath5984"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h72.75v72.75h-72.75z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath5994"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m444 160.5h72v72h-72z",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath6004"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h72.75v72.75h-72.75z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath6016"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m222.89 286.56 64.83-17.77-17.77-64.84-64.83 17.77z",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath6026"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h72.75v72.75h-72.75z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath6054"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m547.59 208.73 75.88-31.19-31.19-75.88-75.88 31.19z",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath6064"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h72.75v72.75h-72.75z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath6078"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m459.73 183.12 66.11-24.11-24.11-66.114-66.11 24.114z",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath6088"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h72.75v72.75h-72.75z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath6100"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m402.23 223.99 70.49-14.68-14.68-70.49-70.49 14.69z",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath6110"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h72.75v72.75h-72.75z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath6120"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m516 184.5h72v72h-72z",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath6130"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h72.75v72.75h-72.75z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath6146"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m517.28 155.6 61.2-37.93-37.93-61.197-61.2 37.929z",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath6156"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h72.75v72.75h-72.75z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath6170"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m427.54 288.04 29.57-53.69-53.69-29.57-29.57 53.69z",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath6180"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h72.75v72.75h-72.75z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath6190"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m282.44 199.91 45.4-55.87-55.87-45.411-45.41 55.881z",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath6200"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h72.75v72.75h-72.75z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-606.27 -435.34)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.35278 0 0 -.35278 538.24 558.56)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m192.86 38.571h445.71v310.71h-445.71z",
    fill: "#ffffff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath5890)"
  }, /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1,0,0,-1,7.2,494.7)",
    fill: "#000000",
    fontFamily: "TimesNewRomanPSMT",
    fontSize: "39.8px"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: "0 27.780399 43.5014 59.222401 77.211998 107.2212 127.4396 137.94679 155.9364 167.9162 185.90581 196.41299 214.4026 232.3922 243.6158 257.108 277.32639 297.5448 308.7684 326.758 335.03641 355.25479 373.24438 386.7366 397.96021 413.68121 423.47198 436.9642 463.23221",
    y: 0
  }, "Assemble electronic parts (R)"))), /*#__PURE__*/React.createElement("path", {
    d: "m290.63 235.5c0 27.96 22.66 50.62 50.62 50.62s50.63-22.66 50.63-50.62-22.67-50.63-50.63-50.63-50.62 22.67-50.62 50.63z",
    fill: "#000000",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m290.63 235.5c0 27.96 22.66 50.62 50.62 50.62s50.63-22.66 50.63-50.62-22.67-50.63-50.63-50.63-50.62 22.67-50.62 50.63z",
    fill: "none",
    stroke: "#000000",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "m319.13 162.37h17.25v45h-17.25z",
    fill: "#000000",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m319.13 162.37h17.25v45h-17.25z",
    fill: "none",
    stroke: "#000000",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "m346.88 162.37h17.25v45h-17.25z",
    fill: "#000000",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m346.88 162.37h17.25v45h-17.25z",
    fill: "none",
    stroke: "#000000",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "m313.13 246c0 8.91 7.55 16.12 16.87 16.12s16.88-7.21 16.88-16.12-7.56-16.13-16.88-16.13-16.87 7.22-16.87 16.13z",
    fill: "#ffffff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m313.13 246c0 8.91 7.55 16.12 16.87 16.12s16.88-7.21 16.88-16.12-7.56-16.13-16.88-16.13-16.87 7.22-16.87 16.13z",
    fill: "none",
    stroke: "#000000",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "m336.38 246c0 8.91 7.55 16.12 16.87 16.12s16.88-7.21 16.88-16.12-7.56-16.13-16.88-16.13-16.87 7.22-16.87 16.13z",
    fill: "#ffffff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m336.38 246c0 8.91 7.55 16.12 16.87 16.12s16.88-7.21 16.88-16.12-7.56-16.13-16.88-16.13-16.87 7.22-16.87 16.13z",
    fill: "none",
    stroke: "#ffffff",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m332.7 243.89c0-1.08-0.87-1.95-1.95-1.95s-1.95 0.87-1.95 1.95 0.87 1.95 1.95 1.95 1.95-0.87 1.95-1.95z",
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m351.63 244.09c0-1.08-0.87-1.95-1.95-1.95-1.07 0-1.94 0.87-1.94 1.95s0.87 1.95 1.94 1.95c1.08 0 1.95-0.87 1.95-1.95z",
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m313.13 279.37 25.5 50.25 25.5-50.25z",
    fill: "#4472c4"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m313.13 279.37 25.5 50.25 25.5-50.25z",
    fill: "none",
    stroke: "#2f528f",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath5930)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m290.89 223.52-13.49 4.27c-7.44 2.36-12.32 7.94-10.89 12.46 1.43 4.53 8.63 6.29 16.08 3.94l13.48-4.27z",
    fill: "#000000",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath5940)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m290.89 223.52-13.49 4.27c-7.44 2.36-12.32 7.94-10.89 12.46 1.43 4.53 8.63 6.29 16.08 3.94l13.48-4.27z",
    fill: "none",
    stroke: "#000000",
    strokeMiterlimit: 10
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath5950)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m375.97 241.43 16.44 10.59c9.07 5.85 19.01 6.58 22.2 1.64s-1.59-13.69-10.66-19.54l-16.43-10.6z",
    fill: "#000000",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath5960)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m375.97 241.43 16.44 10.59c9.07 5.85 19.01 6.58 22.2 1.64s-1.59-13.69-10.66-19.54l-16.43-10.6z",
    fill: "none",
    stroke: "#000000",
    strokeMiterlimit: 10
  })), /*#__PURE__*/React.createElement("path", {
    d: "m357.38 214.5c0-5.59-7.22-10.13-16.13-10.13s-16.12 4.54-16.12 10.13h5.06c0-2.8 4.95-5.06 11.06-5.06s11.06 2.26 11.06 5.06z",
    fill: "#ffffff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m357.38 214.5c0-5.59-7.22-10.13-16.13-10.13s-16.12 4.54-16.12 10.13h5.06c0-2.8 4.95-5.06 11.06-5.06s11.06 2.26 11.06 5.06z",
    fill: "none",
    stroke: "#a5a5a5",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath5974)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-.48411 .47066 -.47066 -.48411 434.53 139.31)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "scale(.98969)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath5984)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m66.59 70.371-7.778-6.225-2.045-4.088-24.876-24.875-3.075 3.15-3.243-3.242 0.531-0.53c0.258-0.249 0.402-0.593 0.399-0.951-0.01-0.323-0.155-0.627-0.399-0.839-0.247-0.26-0.592-0.405-0.951-0.399-0.312 7e-3 -0.606 0.143-0.814 0.375l-0.525 0.581-19.301-19.225c-0.6803-0.65-1.2055-1.444-1.5367-2.325-0.8705-2.5285-0.2188-5.332 1.6777-7.2173 2.3529-2.3835 6.0943-2.6917 8.8053-0.7252l0.88 0.7252 19.055 19.055-0.53 0.53c-0.258 0.249-0.402 0.593-0.399 0.951 0.01 0.323 0.155 0.627 0.399 0.839 0.25 0.257 0.593 0.401 0.951 0.399 0.312-7e-3 0.606-0.143 0.814-0.375l0.529-0.582 3.18 3.18-3.15 3.225 24.89 24.891 4.09 2.042 6.219 7.858zm-30.361-41.799-1.101-1.102c-0.387 0.229-0.826 0.354-1.275 0.364-0.758 0.015-1.489-0.278-2.025-0.813-0.536-0.483-0.849-1.166-0.864-1.888-0.012-0.508 0.118-1.01 0.375-1.45l-18.005-18.012-0.788-0.6465c-2.114-1.5091-5.0127-1.2545-6.8318 0.6-1.4879 1.4764-2.0022 3.6729-1.3245 5.656 0.2578 0.668 0.6614 1.269 1.1813 1.76l18.268 18.196c0.387-0.229 0.826-0.354 1.275-0.364 0.759-0.019 1.491 0.275 2.025 0.813 0.536 0.483 0.849 1.166 0.864 1.888 0.012 0.508-0.118 1.01-0.375 1.449l1.175 1.176 2.566-2.629 1.715-1.771 0.491-0.502 0.024-0.025zm26.97 31.34-4.009-2.005-25.05-25.05-1.206 1.251 25.066 25.064 2.009 4.011 6.472 5.175 1.903-1.903z",
    fill: "#000000"
  }))))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath5994)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(444,160.5)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "scale(.98969)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath6004)",
    fill: "#000000"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m33.641 31.373c0.298-0.288 0.773-0.279 1.061 0.019 0.28 0.29 0.28 0.751 0 1.042l-5.331 5.33 5.615 5.614 5.33-5.33c0.298-0.288 0.773-0.279 1.061 0.019 0.28 0.29 0.28 0.751 0 1.042l-5.331 5.329 4.088 4.088-5.303 5.303c-4.177 4.185-10.884 4.413-15.335 0.52l-1.624 1.68c-3.539 3.643-8.3987 5.704-13.478 5.715h-2.5102v-1.5h2.5102c4.6727-0.011 9.1438-1.907 12.399-5.259l1.64-1.695c-3.915-4.451-3.702-11.177 0.488-15.371l5.303-5.303 4.087 4.087zm-13.66 7.607c-3.807 3.807-3.807 9.981 0 13.788 3.808 3.808 9.982 3.808 13.789 0l4.243-4.242-13.789-13.789z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m68.414 12.366c-4.477-9e-3 -8.78 1.732-11.992 4.85l-1.932 1.869c3.884 4.454 3.656 11.155-0.521 15.335l-5.303 5.304-15.91-15.911 5.303-5.303c4.191-4.198 10.924-4.411 15.372-0.487l1.95-1.885c3.491-3.39 8.168-5.281 13.033-5.272h2.47v1.5zm-29.294 7.205-4.243 4.242 13.789 13.789 4.243-4.243c3.828-3.787 3.862-9.96 0.075-13.788s-9.96-3.862-13.788-0.075c-0.026 0.025-0.051 0.05-0.076 0.075z"
  }))))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath6016)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.9005 -.24678 .24678 .9005 205.12 221.72)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "scale(.98969)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath6026)",
    fill: "#000000"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m25.134 61.116h-13.5v-13.5h13.5zm-1.5-12h-10.5v10.5h10.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m11.634 11.616h13.5v13.5h-13.5zm1.5 12h10.5v-10.5h-10.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m49.134 61.116v-13.5h13.5v13.5zm12-12h-10.5v10.5h10.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m19.134 40.116h13.5v19.5h10.5v1.5h-12v-19.5h-12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m40.134 47.616h1.5v6h-1.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m50.634 41.616h-10.5v-9h-9v-10.5h6.75v1.5h-5.25v7.5h9v9h7.5v-9h13.5v1.5h-12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m13.134 43.116h-1.5v-12h13.5v1.5h-12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m44.634 13.116h-15v-1.5h16.5v13.5h-1.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m56.634 40.116h6v1.5h-6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m53.634 11.616h9v1.5h-7.5v9h7.5v1.5h-9z"
  }))))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath6054)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.0539 -.43325 .43325 1.0539 516.4 132.85)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "scale(.98969)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath6064)",
    fill: "#000000"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m49.134 41.616h-1.5v-4.5h-4.5v-1.5h4.5v-4.5h1.5v4.5h4.5v1.5h-4.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m13.134 35.616h10.5v1.5h-10.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m63.384 42.366h-0.75v6.75c-2e-3 2.07-1.68 3.748-3.75 3.75h-51c-2.07-2e-3 -3.7475-1.68-3.75-3.75v-25.5c0.0025-2.07 1.68-3.748 3.75-3.75h51c2.07 2e-3 3.748 1.68 3.75 3.75v6.75h0.75c2.07 2e-3 3.748 1.68 3.75 3.75v4.5c-2e-3 2.07-1.68 3.748-3.75 3.75zm-2.25-18.75c0-1.243-1.007-2.25-2.25-2.25h-51c-1.2426 0-2.25 1.007-2.25 2.25v25.5c0 1.243 1.0074 2.25 2.25 2.25h51c1.243 0 2.25-1.007 2.25-2.25zm4.5 10.5c0-1.243-1.007-2.25-2.25-2.25h-0.75v9h0.75c1.243 0 2.25-1.007 2.25-2.25z"
  }))))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath6078)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.91821 -.33491 .33491 .91821 435.62 117.01)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "scale(.98969)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath6088)",
    fill: "#000000"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m23.634 23.616h25.5v25.5h-25.5zm1.5 24h22.5v-22.5h-22.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m63.384 50.616v1.5h-6.75v0.75c-2e-3 2.07-1.68 3.748-3.75 3.75h-0.75v6.75h-1.5v-6.75h-4.5v6.75h-1.5v-6.75h-4.5v6.75h-1.5v-6.75h-4.5v6.75h-1.5v-6.75h-4.5v6.75h-1.5v-6.75h-4.5v6.75h-1.5v-6.75h-0.75c-2.07-2e-3 -3.748-1.68-3.75-3.75v-0.75h-6.75v-1.5h6.75v-4.5h-6.75v-1.5h6.75v-4.5h-6.75v-1.5h6.75v-4.5h-6.75v-1.5h6.75v-4.5h-6.75v-1.5h6.75v-4.5h-6.75v-1.5h6.75v-0.75c2e-3 -2.07 1.68-3.748 3.75-3.75h0.75v-6.75h1.5v6.75h4.5v-6.75h1.5v6.75h4.5v-6.75h1.5v6.75h4.5v-6.75h1.5v6.75h4.5v-6.75h1.5v6.75h4.5v-6.75h1.5v6.75h0.75c2.07 2e-3 3.748 1.68 3.75 3.75v0.75h6.75v1.5h-6.75v4.5h6.75v1.5h-6.75v4.5h6.75v1.5h-6.75v4.5h6.75v1.5h-6.75v4.5h6.75v1.5h-6.75v4.5zm-8.25-30.75c0-1.243-1.007-2.25-2.25-2.25h-33c-1.243 0-2.25 1.007-2.25 2.25v33c0 1.243 1.007 2.25 2.25 2.25h33c1.243 0 2.25-1.007 2.25-2.25z"
  }))))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath6100)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.97898 -.20393 .20393 .97899 387.55 153.51)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "scale(.98969)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath6110)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m62.634 35.616c-2e-3 1.489-0.885 2.836-2.25 3.432v4.068h-4.5v13.5c-2e-3 2.07-1.68 3.748-3.75 3.75h-12.75c-2.07-2e-3 -3.748-1.68-3.75-3.75v-39.75c0-1.243-1.007-2.25-2.25-2.25h-12.75c-1.243 0-2.25 1.007-2.25 2.25v12.75h4.5v4.068c1.365 0.596 2.248 1.943 2.25 3.432v18h-2.25v6h-10.5v-6h-2.25v-18c2e-3 -1.489 0.885-2.836 2.25-3.432v-4.068h4.5v-12.75c2e-3 -2.07 1.68-3.748 3.75-3.75h12.75c2.07 2e-3 3.748 1.68 3.75 3.75v39.75c0 1.243 1.007 2.25 2.25 2.25h12.75c1.243 0 2.25-1.007 2.25-2.25v-13.5h-4.5v-4.068c-1.365-0.596-2.248-1.943-2.25-3.432v-18h2.25v-6h10.5v6h2.25zm-48.75 24h7.5v-4.5h-7.5zm0-26.25v1.5c-1.243 0-2.25 1.007-2.25 2.25v16.5h12v-16.5c0-1.243-1.007-2.25-2.25-2.25v-3.75h-7.5zm45-20.25h-7.5v4.5h7.5zm2.25 6h-12v16.5c0 1.243 1.007 2.25 2.25 2.25v3.75h7.5v-3.75c1.243 0 2.25-1.007 2.25-2.25z",
    fill: "#000000"
  }))))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath6120)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(516,184.5)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "scale(.98969)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath6130)",
    fill: "#000000"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m49.885 27.421v1.5h-5.25v-8.25h-1.5v-1.5h14.25v25.5h-6.33l-1.5-1.5h6.33v-7.5h-12.001v-1.5h12.001v-5.25h-2.25v-1.5h2.25v-6.75h-9.75v6.75z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m60.055 53.671-1.5-1.5h5.579v-39.75h-48.083c0.824 0.805 1.359 1.86 1.523 3l0.06 0.75v36h25.108l1.5 1.5h-26.608v2.25c0 2.899-2.351 5.25-5.25 5.25-2.8995 0-5.25-2.351-5.25-5.25v-39.75l0.06-0.75c0.3585-2.453 2.3835-4.321 4.857-4.48l53.583-0.02v42.75zm-51.421 2.25c0 2.071 1.679 3.75 3.75 3.75s3.75-1.679 3.75-3.75v-36.083c-2.017 2.071-5.331 2.115-7.4017 0.099-0.0332-0.033-0.066-0.066-0.0983-0.099zm0-39.75c0 2.071 1.679 3.75 3.75 3.75s3.75-1.679 3.75-3.75-1.679-3.75-3.75-3.75c-2.07 2e-3 -3.7475 1.68-3.75 3.75z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m33.759 43.171 1.497 1.5h-10.872v-25.5h14.251v1.5h-1.5v8.25h-5.25v-1.5h3.75v-6.75h-9.751v6.75h2.251v1.5h-2.251v5.195h4.615l0.497 1.5h-5.112v7.555z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m33.009 34.543 7.065 2.331 22.084 22.155c0.581 0.511 0.638 1.396 0.128 1.978-0.029 0.032-0.06 0.064-0.092 0.094l-2.625 2.625c-0.57 0.582-1.504 0.592-2.086 0.022-7e-3 -7e-3 -0.014-0.015-0.022-0.022l-22.12-22.155zm25.506 28.116 2.575-2.576-2.307-2.306-2.576 2.576zm-3.619-3.618 0.251 0.252 2.604-2.602-0.261-0.279-16.218-16.221c-0.288 1.298-1.307 2.309-2.608 2.586zm-18.243-18.279 0.307 0.308c0.302 0.184 0.649 0.282 1.003 0.283 0.502 0 0.983-0.201 1.335-0.559 0.64-0.62 0.738-1.61 0.233-2.344l-0.264-0.264-3.133-1.033-0.509 0.509z"
  }))))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath6146)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.84999 -.5268 .5268 .84999 479.35 94.402)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "scale(.98969)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath6156)",
    fill: "#000000"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m45.527 34.978-1.06-1.062 19.769-19.725c1.03-1.641 0.83-3.769-0.488-5.1903-0.755-0.7506-1.777-1.173-2.842-1.176-0.814-0.0028-1.608 0.253-2.267 0.7305 0 0-0.249 0.1695-0.406 0.3-0.044 0.036-0.164 0.15-0.164 0.15l-19.281 19.233-1.061-1.06 19.315-19.229 0.717-0.6082c0.916-0.6632 2.019-1.0188 3.15-1.0155 1.463 0.0011 2.865 0.5821 3.9 1.6155 1.864 1.9624 2.113 4.956 0.6 7.2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m56.158 45.772c5.636-0.026 10.226 4.522 10.251 10.158 6e-3 1.287-0.232 2.563-0.7 3.761l-6.075-6.075-4.8 1.275-1.2 4.725 6.075 6.075c-1.136 0.426-2.339 0.643-3.551 0.643-2.566-6e-3 -5.039-0.956-6.949-2.668-2.836-2.599-3.992-6.559-3-10.275l-11.834-11.834-16.427 16.409-1.894 3.712-7.0998 5.694-3.576-3.576 5.6998-7.101 3.706-1.893 16.425-16.406-23.25-23.255c-1.3424-1.298-1.8863-3.216-1.425-5.025 0.457-1.8071 1.8679-3.2181 3.675-3.675 1.809-0.4541 3.723 0.0888 5.025 1.425l38.25 38.25c0.873-0.228 1.772-0.343 2.674-0.344zm-40.395 10.174-3.72 1.94-4.6503 5.8 1.674 1.674 5.8003-4.65 1.853-3.644 16.593-16.568-1.04-1.039zm36.66-8.77-38.25-38.25c-0.708-0.7247-1.676-1.1362-2.689-1.143-0.307 0-0.613 0.0381-0.911 0.1132-1.2671 0.3258-2.2571 1.3155-2.5833 2.5833-0.3247 1.283 0.0559 2.642 0.9998 3.57l0.0157 0.015 0.015 0.015 38.25 38.25 0.608 0.607-0.217 0.829c-0.865 3.173 0.12 6.563 2.55 8.779 1.771 1.594 4.107 2.412 6.486 2.27l5e-3 -0.014-4.732-4.728 1.627-6.405 6.487-1.725 4.777 4.777c6e-3 7e-3 0.013 5e-3 0.013-5e-3 0.187-2.405-0.614-4.783-2.218-6.584-1.664-1.83-4.025-2.869-6.498-2.861-0.775 2e-3 -1.547 0.103-2.297 0.3l-0.831 0.216z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m11.55 13.191c-0.948 0-1.7163-0.768-1.7168-1.715-4e-4 -0.948 0.7678-1.7166 1.7148-1.717 0.948-5e-4 1.717 0.768 1.717 1.715v1e-3c0 0.947-0.768 1.716-1.715 1.716z"
  }))))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath6170)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.74563 .41068 -.41068 .74563 403.42 204.78)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "scale(.98969)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath6180)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m57.892 67.924c0.374 2e-3 0.746-0.018 1.117-0.058l-5.475-5.475 1.875-6.998 7.004-1.875 5.388 5.448c0.566-5.474-3.412-10.372-8.887-10.939-0.332-0.034-0.665-0.052-0.999-0.053-0.857 0-1.71 0.114-2.537 0.339l-0.84 0.229-30.342-30.343 0.248-0.852c1.011-3.591-0.1-7.4445-2.868-9.9453-1.833-1.6686-4.222-2.5936-6.701-2.5942-0.373-0.0011-0.745 0.0184-1.116 0.0585l5.475 5.475-1.872 6.995-6.922 1.875-5.4713-5.464c-0.5761 5.475 3.3945 10.38 8.8683 10.956 0.338 0.035 0.677 0.054 1.016 0.054 0.857 1e-3 1.71-0.113 2.536-0.338l0.84-0.229 30.343 30.342-0.248 0.853c-1.011 3.591 0.1 7.445 2.868 9.945 1.833 1.669 4.222 2.594 6.7 2.594m0 1.5c-6.3 0.01-11.414-5.09-11.424-11.39-1e-3 -1.037 0.139-2.069 0.416-3.068l-29.1-29.1c-0.955 0.26-1.941 0.392-2.931 0.391-6.3329-0.015-11.454-5.161-11.439-11.494 0.0033-1.356 0.2471-2.701 0.7202-3.972l6.75 6.75 5.25-1.425 1.425-5.325-6.75-6.75c1.301-0.4839 2.678-0.7323 4.066-0.7335 6.301-0.0092 11.415 5.0907 11.425 11.39 1e-3 1.037-0.139 2.069-0.416 3.068l29.1 29.1c0.955-0.26 1.941-0.392 2.931-0.392 6.333 0.016 11.454 5.162 11.439 11.495-3e-3 1.356-0.247 2.701-0.72 3.972l-6.675-6.75-5.325 1.425-1.425 5.325 6.75 6.75c-1.301 0.484-2.678 0.732-4.067 0.733z",
    fill: "#000000"
  }))))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath6190)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.77606 .63066 -.63066 .77606 271.97 98.629)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "scale(.98969)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath6200)",
    fill: "#000000"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m49.885 27.421v1.5h-5.25v-8.25h-1.5v-1.5h14.25v25.5h-6.33l-1.5-1.5h6.33v-7.5h-12.001v-1.5h12.001v-5.25h-2.25v-1.5h2.25v-6.75h-9.75v6.75z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m60.055 53.671-1.5-1.5h5.579v-39.75h-48.083c0.824 0.805 1.359 1.86 1.523 3l0.06 0.75v36h25.108l1.5 1.5h-26.608v2.25c0 2.899-2.351 5.25-5.25 5.25-2.8995 0-5.25-2.351-5.25-5.25v-39.75l0.06-0.75c0.3585-2.453 2.3835-4.321 4.857-4.48l53.583-0.02v42.75zm-51.421 2.25c0 2.071 1.679 3.75 3.75 3.75s3.75-1.679 3.75-3.75v-36.083c-2.017 2.071-5.331 2.115-7.4017 0.099-0.0332-0.033-0.066-0.066-0.0983-0.099zm0-39.75c0 2.071 1.679 3.75 3.75 3.75s3.75-1.679 3.75-3.75-1.679-3.75-3.75-3.75c-2.07 2e-3 -3.7475 1.68-3.75 3.75z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m33.759 43.171 1.497 1.5h-10.872v-25.5h14.251v1.5h-1.5v8.25h-5.25v-1.5h3.75v-6.75h-9.751v6.75h2.251v1.5h-2.251v5.195h4.615l0.497 1.5h-5.112v7.555z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m33.009 34.543 7.065 2.331 22.084 22.155c0.581 0.511 0.638 1.396 0.128 1.978-0.029 0.032-0.06 0.064-0.092 0.094l-2.625 2.625c-0.57 0.582-1.504 0.592-2.086 0.022-7e-3 -7e-3 -0.014-0.015-0.022-0.022l-22.12-22.155zm25.506 28.116 2.575-2.576-2.307-2.306-2.576 2.576zm-3.619-3.618 0.251 0.252 2.604-2.602-0.261-0.279-16.218-16.221c-0.288 1.298-1.307 2.309-2.608 2.586zm-18.243-18.279 0.307 0.308c0.302 0.184 0.649 0.282 1.003 0.283 0.502 0 0.983-0.201 1.335-0.559 0.64-0.62 0.738-1.61 0.233-2.344l-0.264-0.264-3.133-1.033-0.509 0.509z"
  })))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg07);
export default __webpack_public_path__ + "static/media/07.ed85d350d5ea9e6dc896c05b841e7bcb.svg";
export { ForwardRef as ReactComponent };